import { FETCH_DOCUMENTS_FAILURE,
  FETCH_DOCUMENTS_SUCCESS,
  FETCH_DOCUMENTS_REQUEST,
  FETCH_DISCLOSURES_FAILURE,
  FETCH_DISCLOSURES_SUCCESS,
  FETCH_DISCLOSURES_REQUEST,
  FETCH_NETGROSSDISCLOSURES_FAILURE,
  FETCH_NETGROSSDISCLOSURES_REQUEST,
  FETCH_NETGROSSDISCLOSURES_SUCCESS
} from './action-types';
import {
  getExpenseDisclosure,
  getNetGrossExpenseDisclosure,
  getFrequentTraderDisclosuresFund,
  getFrequentTraderDisclosuresPlan
} from '../../../utils/disclaimers-helpers';
import format from '../../../utils/format';
import { isModel } from '../../../utils/sharedHelpers';
import { FUND_TYPES } from '../../profile/get-fund-type';
import { internalApiClient } from '../../../services/screener-service';
import { getDocumentsForFunds, getProfileFootnotes } from '../../../hooks/api';
import { FIELDS } from '../../../shared/screener-constants';

export const fetchDocumentsRequest = () => {
  return {
    type: FETCH_DOCUMENTS_REQUEST
  };
};

export const fetchDocumentsSuccess = (data, xid) => {
  return {
    type: FETCH_DOCUMENTS_SUCCESS,
    payload: data,
    xid
  };
};

export const fetchDocumentsFailure = error => {
  return {
    type: FETCH_DOCUMENTS_FAILURE,
    payload: error
  };
};

export const fetchDisclosuresRequest = () => {
  return {
    type: FETCH_DISCLOSURES_REQUEST
  };
};

export const fetchDisclosuresSuccess = (data, xid) => {
  return {
    type: FETCH_DISCLOSURES_SUCCESS,
    payload: data,
    xid
  };
};

export const fetchDisclosuresFailure = error => {
  return {
    type: FETCH_DISCLOSURES_FAILURE,
    payload: error
  };
};

export const fetchNetGrossDisclosuresRequest = () => {
  return {
    type: FETCH_NETGROSSDISCLOSURES_REQUEST
  };
};

export const fetchNetGrossDisclosuresSuccess = (data, xid) => {
  return {
    type: FETCH_NETGROSSDISCLOSURES_SUCCESS,
    payload: data,
    xid
  };
};

export const fetchNetGrossDisclosuresFailure = error => {
  return {
    type: FETCH_NETGROSSDISCLOSURES_FAILURE,
    payload: error
  };
};

const getFundSpecificDisclosures = ({ disclosureResult, item, expand, planDisclosures, xid, holdingsByContext }) => {
  const fundSpecificDisclosures = [];
  const nonPropMFCapNote = item[FIELDS.TCEXPENSEWAIVERCAPNOTE];
  const expenseDisclosure = getExpenseDisclosure(item, nonPropMFCapNote);
  const frequentTraderDisclosuresFund = getFrequentTraderDisclosuresFund(item);
  const frequentTraderDisclosuresPlan = getFrequentTraderDisclosuresPlan(item, holdingsByContext);

  if (disclosureResult?.numberedNote) {
    fundSpecificDisclosures.push(disclosureResult.numberedNote);
  }
  if (disclosureResult?.expenseWaiverCapNote) {
    fundSpecificDisclosures.push(disclosureResult.expenseWaiverCapNote);
  }
  if (format.text(expenseDisclosure) !== '--') {
    fundSpecificDisclosures.push(expenseDisclosure);
  }
  if (format.text(frequentTraderDisclosuresFund) !== '--') {
    fundSpecificDisclosures.push(frequentTraderDisclosuresFund);
  }
  if (format.text(frequentTraderDisclosuresPlan) !== '--') {
    fundSpecificDisclosures.push(frequentTraderDisclosuresPlan);
  }
  // combine fund disclosures and plan footnote disclosure
  if (planDisclosures[xid]) {
    fundSpecificDisclosures.push(planDisclosures[xid]);
  }


  if (fundSpecificDisclosures.length === 0) {
    fundSpecificDisclosures.push(`The performance data quoted represents past performance,
                                  and is no guarantee of future results. See disclaimers
                                  on bottom of the page for additional information.`);
  }

  if (disclosureResult?.modelNameChangedDisclosureList) {
    disclosureResult.modelNameChangedDisclosureList.forEach(note => fundSpecificDisclosures.push(note));
  }

  const joinedDisclosures = fundSpecificDisclosures.join('<br></br>');
  return joinedDisclosures;
};

const getNetGrossDisclosures = ({ disclosureResult, item }) => {

  const nonPropMFCapNote = item[FIELDS.TCEXPENSEWAIVERCAPNOTE];
  const expenseDisclosure = getNetGrossExpenseDisclosure(item, nonPropMFCapNote);

  if (!expenseDisclosure && disclosureResult?.expenseWaiverCapNote) {
    return disclosureResult.expenseWaiverCapNote;
  }
  if (format.text(expenseDisclosure) !== '--') {
    return expenseDisclosure;
  }
  return '';
};

export const fetchDocumentsData = (fundType, xid, yyy, channel) => {
  return (dispatch, getState) => {

    const state = getState();
    const stateDocuments = state.rowDocsAndDisclosuresReducer.documents;
    const isLoaded = stateDocuments[xid];

    if (!isLoaded) {
      internalApiClient(yyy, channel).then(service => {
        const inputs = {
          client: service,
          xid
        };
        dispatch(fetchDocumentsRequest());
        getDocumentsForFunds(inputs).then(shareClassResult => {

          const documents = [];

          if (shareClassResult.prospectusUrl || shareClassResult.factSheetUrl || shareClassResult.factSheetUrlList) {
            if (shareClassResult.prospectusUrl) {
              documents.push({
                label: isModel(fundType) ? 'Disclosure Document' : 'Prospectus',
                url: shareClassResult.prospectusUrl
              });
            }

            if (shareClassResult.factSheetUrl || shareClassResult.factSheetUrlList) {
              documents.push({
                label: `Fact Sheet${shareClassResult.factSheetUrlList ? 's' : ''}`,
                url: shareClassResult.factSheetUrl,
                urlList: shareClassResult.factSheetUrlList
              });
            }
          }

          const isFdicInsuredProduct = fundType === FUND_TYPES.FDICINSUREDBANKPRODUCT;
          if (isFdicInsuredProduct) {
            documents.push({
              label: 'Terms & Conditions',
              url: 'https://www.tiaa.org/public/pdf/prospectuses/BanksTerms.pdf'
            });
          }

          dispatch(fetchDocumentsSuccess(documents, xid));

        }).catch(error => {
          dispatch(fetchDocumentsFailure(error.message));
        });
      }).catch(error => {
        dispatch(fetchDocumentsFailure(error.message));
      });
    }

  };
};

export const fetchDisclosuresData = (xid, item, yyy, channel) => {
  return async (dispatch, getState) => {

    const state = getState();
    const stateDisclosures = state.rowDocsAndDisclosuresReducer.disclosures;
    const isLoaded = stateDisclosures[xid];
    const planDisclosures = state.filterReducer.planDisclosures;
    const isSearchedPlanInContext = state.filterReducer.isSearchedPlanInContext;
    const searchedHoldings = state.filterReducer.searchedHoldings;
    const participantHoldings = state.filterReducer.participantHoldings;
    const holdingsByContext = isSearchedPlanInContext ? searchedHoldings : participantHoldings;

    if (!isLoaded) {
      try {
        const service = await internalApiClient(yyy, channel);
        const inputs = {
          client: service,
          xid
        };
        await dispatch(fetchDisclosuresRequest());
        const disclosureResult = await getProfileFootnotes(inputs);

        const fundSpecificDisclosures = getFundSpecificDisclosures({
          disclosureResult,
          item,
          planDisclosures,
          xid,
          holdingsByContext
        });

        await dispatch(fetchDisclosuresSuccess(fundSpecificDisclosures, xid));
        return fundSpecificDisclosures;
      } catch (error) {
        dispatch(fetchDisclosuresFailure(error.message));
        return null;
      }
    }
    return null;
  };
};


export const fetchNetGrossDisclosuresData = (xid, item, yyy, channel) => {
  return async (dispatch, getState) => {

    const state = getState();
    const stateDisclosures = state.rowDocsAndDisclosuresReducer.netGrossDisclosures;
    const isLoaded = stateDisclosures[xid];
    if (!isLoaded) {
      try {
        const service = await internalApiClient(yyy, channel);
        const inputs = {
          client: service,
          xid
        };
        await dispatch(fetchNetGrossDisclosuresRequest());
        const disclosureResult = await getProfileFootnotes(inputs);

        const fundSpecificDisclosures = getNetGrossDisclosures({
          disclosureResult,
          item
        });

        await dispatch(fetchNetGrossDisclosuresSuccess(fundSpecificDisclosures, xid));
        return fundSpecificDisclosures;
      } catch (error) {
        dispatch(fetchNetGrossDisclosuresFailure(error.message));
        return null;
      }
    }
    return null;
  };
};

const rowDocumentsDisclosuresActions = {
  fetchDocumentsData
};

export default rowDocumentsDisclosuresActions;
